import { jsx as c } from "react/jsx-runtime";
import o from "../node_modules/dompurify/dist/purify.es.es.js";
import { marked as _ } from "../node_modules/marked/lib/marked.esm.es.js";
import "react";
const s = ({ markdownText: l, fallbackText: r = "" }) => {
  const t = !l ? r : l, e = o.sanitize(_(t, { breaks: !0 }));
  return /* @__PURE__ */ c(
    "div",
    {
      className: `rcl--max-w-none rcl--p-4 rcl--text-primary [&>*:last-child]:rcl--mb-0 [&>*]:rcl--mb-4 [&_blockquote]:rcl--border-l-4
        [&_blockquote]:rcl--pl-4 [&_blockquote]:rcl--italic [&_code]:rcl--rounded [&_code]:rcl--bg-neutral-100 [&_code]:rcl--p-1
        [&_del]:rcl--line-through [&_em]:rcl--italic [&_h1]:rcl--text-2xl [&_h2]:rcl--text-xl [&_h3]:rcl--text-lg
        [&_h4]:rcl--text-md [&_h5]:rcl--text-base [&_h6]:rcl--text-sm
        [&_img]:rcl--h-auto [&_img]:rcl--max-w-full
        [&_li::marker]:rcl--text-primary [&_li>ol]:rcl--mt-2
        [&_li>ul]:rcl--mt-2 [&_ol]:rcl--list-inside [&_ol]:rcl--list-decimal
        [&_ol]:rcl--pl-5 [&_pre]:rcl--rounded
        [&_pre]:rcl--bg-neutral-100 [&_pre]:rcl--p-4
        [&_s]:rcl--line-through [&_table]:rcl--w-full
        [&_table]:rcl--border-collapse [&_td]:rcl--border [&_td]:rcl--p-2 [&_th]:rcl--border
        [&_th]:rcl--bg-neutral-100 [&_th]:rcl--p-2
        [&_tr:nth-child(even)]:rcl--bg-neutral-100 [&_ul]:rcl--list-inside
        [&_ul]:rcl--list-disc [&_ul]:rcl--pl-5`,
      dangerouslySetInnerHTML: { __html: e }
    }
  );
};
export {
  s as default
};
//# sourceMappingURL=MarkdownRenderer.es.js.map
